module.exports = __webpack_public_path__ + "static/media/footer_brand_logo.f5a459ed.svg";